import "./ShouldKnow.scss";
import React, { useEffect, useState, useContext } from "react";
import { Waves } from "../../Services/Flakes";
import { Waves as waves2 } from "../../Services/Flakes2";
import { Waves as waves3 } from "../../Services/Flakes3";
import articles from "./ArticleAPI.json";
import Slider from "react-slick";
import { mobile } from "../../Services/Agent";
import { Link } from "react-router-dom";
import { AppContext } from "../../stores/application.store";
import Div100vh from 'react-div-100vh';
import { useRef } from "react";

export default function ShouldKnow() {
  const [article, setArticle] = useState(articles.articles);
  let [sliderIndex, setSliderIndex] = useState(0);
  // Application Store context
  let { inArticle, toggleArticle } = useContext(AppContext);
  //console.log(useContext(AppContext))

  let linkRef = useRef(null);


  useEffect(() => {
    //console.log("WTF ", inArticle)
  }, [inArticle])
  // Slick settings
  const settings = {
    className: "center",
    //old settings
    centerMode: true,
    // slidesToShow: 3,
    //old end
    // infinite: mobile() ? true : false,
    slidesToShow: mobile() ? 3 : 5,
    // centerMode: mobile() ? true : false,
    speed: mobile() ? 500 : 0,
    arrows: true,
    // initialSlide: 0,
    draggable: true,
    focusOnSelect: true,
    afterChange: (index) => {
      setSliderIndex(index);
      // console.log(index)
    },
    vertical: mobile() ? false : true,
  };

  const changeIndex = (type) => {
    if (type === "+") {
      sliderIndex < 4 && setSliderIndex(sliderIndex + 1)
    }
    else {
      sliderIndex > 0 && setSliderIndex(sliderIndex - 1)
    }
  }

  // Canvas initialization
  useEffect(() => {
    try {
      let mywaves = new Waves({
        divId: "desktop",
        numberOfNodes: 200,
        // spaceBetweenNodes: 100
        // speed: 0.4,
        // maxWavePower: 50,
        // backgroundColor: "purple",
        // lineWidth: 6,
        dotNumber: 250, // 30 is default
        dotGlobalSpeed: 0.8, // 0.4 is default
        endsOnThisSide: "right", // right is default
      });

      mywaves.animate();
    } catch (err) {
      // console.error(err.message);
    }

    //************** Mobile ***********

    try {
      let mywaves = new Waves({
        divId: "mobile",
        numberOfNodes: 80,
        // spaceBetweenNodes: 100
        // speed: 0.4,
        // maxWavePower: 9999999,
        // backgroundColor: "purple",
        // lineWidth: 6,
        dotNumber: 70, // 30 is default
        dotGlobalSpeed: 0.8, // 0.4 is default
        endsOnThisSide: "right", // right is default
      });

      mywaves.animate();
    } catch (err) {
      // console.error(err.message);
    }
  }, []);
  // Waves 2
  useEffect(() => {
    try {
      let mywaves = new waves2({
        divId: "waves2",
        numberOfNodes: 200,
        // spaceBetweenNodes: 100
        // speed: 0.4,
        // maxWavePower: 50,
        // backgroundColor: "purple",
        // lineWidth: 6,
        dotNumber: mobile() ? 30 : 250, // 30 is default
        dotGlobalSpeed: 0.8, // 0.4 is default
        endsOnThisSide: "right", // right is default
      });

      mywaves.animate();
    } catch (err) {
      // console.error(err.message);
    }
  }, []);
  // Waves 3
  useEffect(() => {
    try {
      let mywaves = new waves3({
        divId: "waves3",
        numberOfNodes: 200,
        // spaceBetweenNodes: 100
        // speed: 0.4,
        // maxWavePower: 50,
        // backgroundColor: "purple",
        // lineWidth: 6,
        dotNumber: 250, // 30 is default
        dotGlobalSpeed: 0.8, // 0.4 is default
        endsOnThisSide: "right", // right is default
      });

      mywaves.animate();
    } catch (err) {
      // console.error(err.message);
    }

    //************** Mobile ***********

    try {
      let mywaves = new Waves({
        divId: "mobile",
        numberOfNodes: 80,
        // spaceBetweenNodes: 100
        // speed: 0.4,
        // maxWavePower: 9999999,
        // backgroundColor: "purple",
        // lineWidth: 6,
        dotNumber: 70, // 30 is default
        dotGlobalSpeed: 0.8, // 0.4 is default
        endsOnThisSide: "right", // right is default
      });

      mywaves.animate();
    } catch (err) {
      // console.error(err.message);
    }
  }, []);

  //Listening To Touch events
  useEffect(() => {
    const prevBtn = document.querySelector(".slick-prev");
    const nextBtn = document.querySelector(".slick-next");
    // window.onscroll = function(e) {
    //     // print "false" if direction is down and "true" if up
    //     //console.log(this.oldScroll > this.scrollX);
    //     this.oldScroll = this.scrollX;
    //   }

    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;

    let gesuredZone = document.querySelector(".sk_main");

    gesuredZone.addEventListener(
      "touchstart",
      function (event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
      },
      false
    );

    gesuredZone.addEventListener(
      "touchend",
      function (event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        handleGesure();
      },
      false
    );

    let imageArr = document.querySelectorAll(".sk_image");
    function handleGesure() {
      let swiped = "swiped: ";
      if (touchendX < touchstartX) {
        // Swiped Left
        // The carusel moved Right
        // console.log(swiped + "left!");
        document.querySelector(".slick-prev").click();
      }
      if (touchendX > touchstartX) {
        // Swiped Right
        // The carusel moved left
        // console.log(swiped + "right!");
        document.querySelector(".slick-next").click();
      }
    }
  }, []);

  return (
    // <Div100vh>
    <section className="should_know watch sec-3">
      <div id="mobile"></div>
      <div
        id="waves2"
        style={{ width: "100%", height: "140%", position: "absolute" }}
      ></div>
      <div
        id="waves3"
        style={{ width: "100%", height: "140%", position: "absolute" }}
      ></div>
      <div id="desktop">
        <div className="sk_wrapper">
          <div className="sk_title">
            <div className="suitcase"></div>
            <div className="title_text">מה שכדאי לדעת</div>
          </div>
          <div className="sk_gallery_wrapper">
            <div className="sk_side">
              <Slider {...settings}>
                {article.map((a, index) => (
                  <div key={index}>
                    <div key={index} className={`sk_image image_${a.image}  ${a.image == (sliderIndex + 1) && "active"}`}></div>
                  </div>
                ))}
              </Slider>
            </div>
            <div className="sk_main">
              <div className={`main_image_${article[sliderIndex].image}`}></div>
              <div className="image_text_wrapper">
                <div
                  className={`right_arrow image_arrow ${sliderIndex === 0 && "in-active"}`}
                  //onClick={() => document.querySelector(".slick-prev").click()}
                  onClick={() => changeIndex("")}
                >
                  <i className="fas fa-arrow-down"></i>
                </div>
                <div onClick={()=> linkRef.current.click()} className="image_title">{article[sliderIndex].title}</div>
                <div  onClick={()=> linkRef.current.click()} className="image_description">
                  {article[sliderIndex].desc}
                </div>
                <Link
                  to={`${article[sliderIndex].link}`}
                  className="article_link"
                  ref={linkRef}
                  //target="_blank"
                  onClick={() => toggleArticle()}
                >
                  לקריאת הכתבה
                </Link>
                <div
                  className={`left_arrow image_arrow ${sliderIndex === 4 && "in-active"}`}
                  // onClick={() => document.querySelector(".slick-next").click()}
                  onClick={() => changeIndex("+")}
                >
                  <i className="fas fa-arrow-down"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    //</Div100vh>
  );
}
